export const IS_USER_LOGGED_IN = 'IS_USER_LOGGED_IN'
export const GET_SECURITY_DATA = 'GET_SECURITY_DATA'
export const GET_SECURITY_LEVEL = 'GET_SECURITY_LEVEL'
export const GET_CURRENT_USER_ID = 'GET_CURRENT_USER_ID'
export const GET_UPDATE_MENU = 'GET_UPDATE_MENU'
export const GET_VERSION = 'GET_VERSION'
export const GET_SHOW_MENU_ADDRESS = 'GET_SHOW_MENU_ADDRESS'
export const GET_SHOW_MENU_PROJECT = 'GET_SHOW_MENU_PROJECT'
export const GET_SHOW_MENU_DISPOSITION = 'GET_SHOW_MENU_DISPOSITION'
export const GET_SHOW_MENU_TICKETING = 'GET_SHOW_MENU_TICKETING'
export const GET_IS_ALL_DAY_LONG = 'GET_IS_ALL_DAY_LONG'
export const GET_DISPOSITION_DEFAULT_DISTANCE = 'GET_DISPOSITION_DEFAULT_DISTANCE'
export const GET_CURRENT_USER_DRAG_AND_DROP = 'GET_CURRENT_USER_DRAG_AND_DROP'
export const GET_CURRENT_USER_RESIZE = 'GET_CURRENT_USER_RESIZE'
export const GET_CURRENT_USER_IS_ABSENCE_APPROVE = 'GET_CURRENT_USER_IS_ABSENCE_APPROVE'
export const GET_IS_CAPELO = 'GET_IS_CAPELO'

//<editor-fold desc="Planning Module Getters">
export const PLANNING_ASSISTANT_GET_START_DATE = 'PLANNING_ASSISTANT_GET_START_DATE'
export const PLANNING_ASSISTANT_GET_END_DATE = 'PLANNING_ASSISTANT_GET_END_DATE'
export const PLANNING_ASSISTANT_GET_COMPANY_FILTER = 'PLANNING_ASSISTANT_GET_COMPANY_FILTER'
export const PLANNING_ASSISTANT_GET_SHIFT_TEMPLATE_ITEM = 'PLANNING_ASSISTANT_GET_SHIFT_TEMPLATE_ITEM'
export const PLANNING_ASSISTANT_GET_PERIODICITY = 'PLANNING_ASSISTANT_GET_PERIODICITY'
export const PLANNING_ASSISTANT_GET_INITIAL_EMPLOYEE_LIST = 'PLANNING_ASSISTANT_GET_INITIAL_EMPLOYEE_LIST'
export const PLANNING_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING = 'PLANNING_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING'
export const PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST = 'PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST'
export const PLANNING_ASSISTANT_GET_TASK_LIST = 'PLANNING_ASSISTANT_GET_TASK_LIST'
export const PLANNING_ASSISTANT_GET_SHIFT_AVAILABILITY = 'PLANNING_ASSISTANT_GET_SHIFT_AVAILABILITY'
export const PLANNING_ASSISTANT_GET_EMPLOYEE_FOR_EXCHANGE = 'PLANNING_ASSISTANT_GET_EMPLOYEE_FOR_EXCHANGE'
export const PLANNING_ASSISTANT_GET_EMPLOYEE_FOR_DELETION = 'PLANNING_ASSISTANT_GET_EMPLOYEE_FOR_DELETION'
export const PLANNING_ASSISTANT_GET_CURRENT_SHIFT = 'PLANNING_ASSISTANT_GET_CURRENT_SHIFT'
export const PLANNING_ASSISTANT_GET_AUTOMATIC_PLANNING_ID = 'PLANNING_ASSISTANT_GET_AUTOMATIC_PLANNING_ID'
export const PLANNING_ASSISTANT_GET_AUTOMATIC_PLANNING_IS_PROJECT = 'PLANNING_ASSISTANT_GET_AUTOMATIC_PLANNING_IS_PROJECT'
export const PLANNING_ASSISTANT_GET_FILTERED_EMPLOYEES_BY_DEPARTMENT = 'PLANNING_ASSISTANT_GET_FILTERED_EMPLOYEES_BY_DEPARTMENT'
export const PLANNING_ASSISTANT_GET_IS_EDITTING_SERIE = 'PLANNING_ASSISTANT_GET_IS_EDITTING_SERIE'
export const PLANNING_ASSISTANT_GET_FREE_PERIODICITY_PLANNING_ID = 'PLANNING_ASSISTANT_GET_FREE_PERIODICITY_PLANNING_ID'
export const PLANNING_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST = 'PLANNING_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST'
export const PLANNING_ASSISTANT_GET_ADDITIONAL_FIELDS_LIST = 'PLANNING_ASSISTANT_GET_ADDITIONAL_FIELDS_LIST'
export const PLANNING_ASSISTANT_GET_ADDITIONAL_FIELDS = 'PLANNING_ASSISTANT_GET_ADDITIONAL_FIELDS'
//</editor-fold>

export const GET_SELECTED_UI_LANGUAGE = 'GET_SELECTED_UI_LANGUAGE'

export const COMPANY_GET_PROFIT_CENTER_CALENDAR_EVENTS = 'COMPANY_GET_PROFIT_CENTER_CALENDAR_EVENTS'
export const COMPANY_GET_BASIC_COMPANY_STRUCTURE = 'COMPANY_GET_BASIC_COMPANY_STRUCTURE'
export const COMPANY_GET_INITIALIZED_STATE = 'COMPANY_GET_INITIALIZED_STATE'
export const COMPANY_GET_COMPANY_STRUCTURE_SCHOOL_LIST = 'COMPANY_GET_COMPANY_STRUCTURE_SCHOOL_LIST'
export const COMPANY_GET_COMPANY_STRUCTURE_HOLIDAY_LIST = 'COMPANY_GET_COMPANY_STRUCTURE_HOLIDAY_LIST'

// Messaging
export const MESSAGING_GET_MESSAGES_LIST = 'MESSAGING_GET_MESSAGES_LIST'
export const MESSAGING_GET_NOTES_LIST = 'MESSAGING_GET_NOTES_LIST'
export const MESSAGING_GET_TASKS_LIST = 'MESSAGING_GET_TASKS_LIST'
export const MESSAGING_GET_SHOW_MENU = 'MESSAGING_GET_SHOW_MENU'
export const MESSAGING_GET_READ_MESSAGES_LIST = 'MESSAGING_GET_READ_MESSAGES_LIST'
export const GET_USER_MESSAGES = 'GET_USER_MESSAGES'

// Absences
export const ABSENCES_ASSISTANT_GET_START_DATE = 'ABSENCES_ASSISTANT_GET_START_DATE'
export const ABSENCES_ASSISTANT_GET_END_DATE = 'ABSENCES_ASSISTANT_GET_END_DATE'
export const ABSENCES_ASSISTANT_GET_COMPANY_FILTER = 'ABSENCES_ASSISTANT_GET_COMPANY_FILTER'
export const ABSENCES_ASSISTANT_GET_ABSENCE_REASON_ITEM = 'ABSENCES_ASSISTANT_GET_ABSENCE_REASON_ITEM'
export const ABSENCES_ASSISTANT_GET_PERIODICITY = 'ABSENCES_ASSISTANT_GET_PERIODICITY'
export const ABSENCES_ASSISTANT_GET_INITIAL_EMPLOYEE_LIST = 'ABSENCES_ASSISTANT_GET_INITIAL_EMPLOYEE_LIST'
export const ABSENCES_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING = 'ABSENCES_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING'
export const ABSENCES_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST = 'ABSENCES_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST'
export const ABSENCES_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST = 'ABSENCES_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST'
export const ABSENCES_ASSISTANT_GET_ABSENCE_APPROVE = 'ABSENCES_ASSISTANT_GET_ABSENCE_APPROVE'
export const ABSENCES_ASSISTANT_GET_ABSENCE_DISAPPROVE = 'ABSENCES_ASSISTANT_GET_ABSENCE_DISAPPROVE'
export const ABSENCES_ASSISTANT_GET_CURRENT_ABSENCE = 'ABSENCES_ASSISTANT_GET_CURRENT_ABSENCE'
export const ABSENCES_ASSISTANT_GET_IS_EDITING_SERIE = 'ABSENCES_ASSISTANT_GET_IS_EDITING_SERIE'
export const ABSENCES_ASSISTANT_GET_PERIODICITY_SERIE = 'ABSENCES_ASSISTANT_GET_PERIODICITY_SERIE'

// CalendarEvent
export const CALENDAR_EVENT_ASSISTANT_GET_START_DATE = 'CALENDAR_EVENT_ASSISTANT_GET_START_DATE'
export const CALENDAR_EVENT_ASSISTANT_GET_END_DATE = 'CALENDAR_EVENT_ASSISTANT_GET_END_DATE'
export const CALENDAR_EVENT_ASSISTANT_GET_COMPANY_FILTER = 'CALENDAR_EVENT_ASSISTANT_GET_COMPANY_FILTER'
export const CALENDAR_EVENT_ASSISTANT_GET_CALENDAR_EVENT_ITEM = 'CALENDAR_EVENT_ASSISTANT_GET_CALENDAR_EVENT_ITEM'
export const CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY = 'CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY'
export const CALENDAR_EVENT_ASSISTANT_GET_INITIAL_EMPLOYEE_LIST = 'CALENDAR_EVENT_ASSISTANT_GET_INITIAL_EMPLOYEE_LIST'
export const CALENDAR_EVENT_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING = 'CALENDAR_EVENT_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING'
export const CALENDAR_EVENT_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST = 'CALENDAR_EVENT_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST'
export const CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST = 'CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST'
export const CALENDAR_EVENT_ASSISTANT_GET_IS_EDITING_SERIE = 'CALENDAR_EVENT_ASSISTANT_GET_IS_EDITING_SERIE'
export const CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY_SERIE = 'CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY_SERIE'

// Address
export const GET_DISPOSITION_ADDRESS = 'GET_DISPOSITION_ADDRESS'

// DispositionJob
export const GET_DISPOSITION_JOB_STATUS_LIST = 'GET_DISPOSITION_JOB_STATUS_LIST'
export const GET_DISPOSITION_JOB_IS_STATUS = 'GET_DISPOSITION_JOB_IS_STATUS'


//Scheduler shift & absence parameters
export const SCHEDULING_GET_PARAMETERS = 'SCHEDULING_GET_PARAMETERS'